module.exports = __webpack_public_path__ + "static/imaware-logo-color-31910d6d9001f14cb6259843402dd3de.svg";